// Constants used for password validations
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 64;
export const PASSWORD_REGEX = /^(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).*$/;
export const PASSWORD_UPPERCASE_REGEX = /[A-Z]/;
export const PASSWORD_LOWERCASE_REGEX = /[a-z]/;
export const PASSWORD_NUMBER_REGEX = /\d/;
export const PASSWORD_SPECIAL_CHAR_REGEX = /[!@#$%^&*(),.?":{}|<>]/;
export const PASSWORD_MIN_SCORE = 3;
